"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deserializeHxPreviewVCFFileResults = void 0;
/*
 * --------------------------------------------------------------------------------------------------------------------
 * <copyright file="HxPreviewVCFFileResults.ts" company="Microsoft">
 *   Copyright (c) Microsoft Corporation.  All rights reserved.
 * </copyright>
 * <summary>
 *   !!! This is an automatically generated file for Actor Command Args and serialization helpers !!!
 *   Please run `MakeGenFiles.bat Actors` from the hxcomm/tools/bin
 *   directory to update its contents.
 * </summary>
 * Generating File: CommandArgsJs.tt
 * --------------------------------------------------------------------------------------------------------------------
 */
var HxObjectID_1 = __importDefault(require("./HxObjectID"));
function deserializeHxPreviewVCFFileResults(values) {
    var i = 0;
    var previewVCFResultId = new HxObjectID_1.default(values[i++]);
    if (i != values.length) {
        throw "Result values not parsed completely";
    }
    return { previewVCFResultId: previewVCFResultId };
}
exports.deserializeHxPreviewVCFFileResults = deserializeHxPreviewVCFFileResults;
